





























































































































import { Component } from 'vue-property-decorator'
import GoalMilestoneMixin from './GoalMilestoneMixin'
import { mixins } from 'vue-class-component'

@Component({})
export default class GoalMilestoneMobile extends mixins(GoalMilestoneMixin) { }
